import BaseAPI from './BaseAPI';

export default class UserAPI extends BaseAPI {
  static getCurrentUser() {
    return this.execute('get', '/users/me').then(user => {
      return user;
    });
  }
}
